import { Button } from "react-bootstrap";
import "./TablePagination.css";

const TablePagination = ({
  currentPage,
  totalPage,
  onPageChange,
  disabled = false,
}) => {
  // Generate page numbers to display (max 3: previous, current, next)
  const getPageNumbers = () => {
    const pages = [];

    // If total pages is 1 or less, just show that page
    if (totalPage <= 1) {
      return [1];
    }

    // If current page is 1, show: [1, 2, 3]
    if (currentPage === 1) {
      for (let i = 1; i <= Math.min(3, totalPage); i++) {
        pages.push(i);
      }
    }
    // If current page is last page, show: [last-2, last-1, last]
    else if (currentPage === totalPage) {
      for (let i = Math.max(1, totalPage - 2); i <= totalPage; i++) {
        pages.push(i);
      }
    }
    // Otherwise show: [current-1, current, current+1]
    else {
      pages.push(currentPage - 1);
      pages.push(currentPage);
      if (currentPage + 1 <= totalPage) {
        pages.push(currentPage + 1);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="table-pagination">
      {/* Previous Button */}
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1 || disabled}
        className="pagination-nav-btn"
      >
        <i className="bi bi-chevron-left"></i>
        Previous
      </Button>

      {/* Page Numbers */}
      <div className="pagination-numbers">
        {pageNumbers.map((pageNum) => (
          <Button
            key={pageNum}
            variant={currentPage === pageNum ? "primary" : "outline-secondary"}
            size="sm"
            onClick={() => onPageChange(pageNum)}
            disabled={disabled}
            className="page-number-btn"
          >
            {pageNum}
          </Button>
        ))}
      </div>

      {/* Next Button */}
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPage || disabled}
        className="pagination-nav-btn"
      >
        Next
        <i className="bi bi-chevron-right"></i>
      </Button>
    </div>
  );
};

export default TablePagination;
